export default __webpack_public_path__ + "static/media/metier_papier_peint.829d33e2.png";